
import { Component, Vue } from 'vue-property-decorator';
import * as SurveyVue from "survey-vue";  
import * as surveyEnv from "@/components/survey/survey-glossary";

import store from "@/store";

import moment from 'moment-timezone';
import {applicationInfoType} from "@/types/Application";

import { namespace } from "vuex-class";   
import "@/store/modules/common";
const commonState = namespace("Common");
import "@/store/modules/application";
import { documentTypesJsonInfoType, applicationJsonInfoType } from '@/types/Common';
const applicationState = namespace("Application");
import {GetFilingLocations} from './GetFilingLocations'
import {RestoreCommonStep} from './RestoreCommonStep'
import {MigrateStore} from './MigrateStore'
import Instructions from './Instructions.vue';
import InstructionsOtherForms from './InstructionsOtherForms.vue'
import RejectedPackageInstructions from './unsuccessfulSubmissions/RejectedPackageInstructions.vue';


@Component({
    components: {Instructions, InstructionsOtherForms, RejectedPackageInstructions}
})
export default class ApplicationStatus extends Vue {

    @commonState.Action
    public UpdateDocumentTypesJson!: (newDocumentTypesJson: documentTypesJsonInfoType[]) => void

    @commonState.Action
    public UpdateLocationsInfo!: (newLocationsInfo) => void

    @applicationState.Action
    public checkAllCompleted!: () => void

    dataLoaded = false;
    showDisclaimer = false;

    windowHeight = 0;
    footerHeight = 0;
    headerHeight = 0;
    buttonMenuHeight = 0;
    infoContentHeaderHeight = 0;
    tableUpdated = 0;

    previousApplications = []
    previousApplicationFields = [
        { key: 'refApps',     label: '',                        sortable:false,  tdClass: 'border-top', thStyle:'font-size:11pt; width:3%;'},
        { key: 'app_type',    label: 'Activity Type',           sortable:true,  tdClass: 'border-top', thStyle:'font-size:11pt; width:30%;'},
        { key: 'lastUpdated', label: 'Last Updated',            sortable:true,  tdClass: 'border-top', thStyle:'font-size:11pt; width:13%;'},
        { key: 'lastFiled',   label: 'Submitted/Filed Date',    sortable:true,  tdClass: 'border-top', thStyle:'font-size:11pt; width:15%;'},
        { key: 'status',      label: 'Status',                  sortable:true,  tdClass: 'border-top', thStyle:'font-size:11pt; width:8%;'},
        { key: 'packageNum',  label: 'CSO Package#',            sortable:false, tdClass: 'border-top', thStyle:'font-size:11pt; width:10%;'},
        { key: 'fileNum',     label: 'Court File #',            sortable:false, tdClass: 'border-top', thStyle:'font-size:11pt; width:13%;'},
        { key: 'edit',        label: '',                        sortable:false, tdClass: 'border-top', thStyle:'font-size:11pt; width:8%;'}
    ]

    refApplicationFields = [        
        { key: 'app_type',    label: 'Activity Type',           sortable:true,  tdClass: 'border-top', thStyle:'font-size:10pt; width:33%;'},
        { key: 'lastUpdated', label: 'Last Updated',            sortable:true,  tdClass: 'border-top', thStyle:'font-size:10pt; width:13%;'},
        { key: 'lastFiled',   label: 'Submitted/Filed Date',    sortable:true,  tdClass: 'border-top', thStyle:'font-size:10pt; width:15%;'},
        { key: 'status',      label: 'Status',                  sortable:true,  tdClass: 'border-top', thStyle:'font-size:10pt; width:8%;'},
        { key: 'packageNum',  label: 'CSO Package#',            sortable:false, tdClass: 'border-top', thStyle:'font-size:10pt; width:10%;'},
        { key: 'fileNum',     label: 'Court File #',            sortable:false, tdClass: 'border-top', thStyle:'font-size:10pt; width:13%;'},
        { key: 'edit',        label: '',                        sortable:false, tdClass: 'border-top', thStyle:'font-size:10pt; width:8%;'}
    ]

    confirmDelete = false;
    currentApplication = {} as applicationInfoType;
    applicationToDelete = {} as applicationJsonInfoType
    indexToDelete = -1 
    applicationId = ''
    error = ''
    deleteErrorMsg = ''
    deleteErrorMsgDesc = ''
    deleteError = false
    
    printingApplicationId = 0;
    printingListOfPdfs: string[] = [];
    showSelectFileForPrint =  false;
    efilingListOfDocs: any[] = [];

    instructionsApplicationId = 0;
    rejectedApplicationId = 0;
    rejectedPackageId = null;
    packageResults = '';
    tempRefApplications = []

    applicationTypes: string[] = [];
    showInstructions = false;
    showJourneyMap = false;
    showActionRequired = false;

    mounted() { 
        this.showDisclaimer = false;
        window.addEventListener('resize', this.getWindowHeight);               
        this.loadDocumentTypes();
        this.extractFilingLocations();
        this.loadApplications();
        this.getWindowHeight();

    }

    public getWindowHeight() {
        this.windowHeight = document.documentElement.clientHeight;
        this.footerHeight = (document.getElementsByName("navigation-footer")[0] as HTMLElement)?.clientHeight;
        this.headerHeight = (document.getElementsByName("navigation-topbar")[0] as HTMLElement)?.clientHeight;
        this.buttonMenuHeight = (document.getElementsByName("button-menu")[0] as HTMLElement)?.clientHeight;
        this.infoContentHeaderHeight = (document.getElementsByName("info-content-header")[0] as HTMLElement)?.clientHeight;

    }

    get getHeight() {        
        return this.windowHeight-this.footerHeight-this.headerHeight-1 + 'px'
    }

    get getTableHeight() {        
        return this.windowHeight-this.footerHeight-this.headerHeight-this.buttonMenuHeight-this.infoContentHeaderHeight-10 + 'px'
    }

    public openTerms() {
        this.$router.push({name: "terms"})
    }

    public loadApplications () {
    //TODO: when extending to use throughout the province, the timezone should be changed accordingly
        this.dataLoaded = false;
        this.$http.get('/app-list/')
        .then((response) => {
            const refAppList = response?.data?.map(app => app.application_reference).filter(id => id)
            // console.log(refAppList)
            this.previousApplications = []
            for (const appJson of response.data) {                
                
                if(refAppList.includes(appJson.id)) continue
                this.tempRefApplications = []
                const app = this.extractApp(response.data, appJson , true)
                this.previousApplications.push(app);
            }
            if (this.previousApplications.length == 0){
                this.$store.commit("Application/setUserType", 'new');
                this.showDisclaimer = true;
            } else {
                this.$store.commit("Application/setUserType", 'returning');
                this.showDisclaimer = false;
            }
            this.dataLoaded = true;       
        },(err) => {
            this.dataLoaded = true;
            this.error = err;        
        });
    }

    public extractApp(appJsons, appJson, mainAppication){

        if(appJson.application_reference){
            const refApp = appJsons.filter(app=>app.id == appJson.application_reference)
            // console.log(refApp)
            if(refApp.length>0) 
                this.tempRefApplications.push(this.extractApp(appJsons, refApp[0], false))
        }

        const app = {lastUpdated:0, lastUpdatedDate:'', id:0, app_type:[], app_type_code:[], lastFiled:0, lastFiledDate:'', packageNum:'', listOfPdfs:[], status:'', packageResults:'',fileNum:'', efilingDocs:[], rejected:false, last_efiling_submission:{package_number:'',package_url:''}} as applicationJsonInfoType;
        app.lastUpdated = appJson.last_updated?moment(appJson.last_updated).tz("America/Vancouver").diff('2000-01-01','minutes'):0;
        app.lastUpdatedDate = appJson.last_updated?moment(appJson.last_updated).tz("America/Vancouver").format():'';                
        app.lastFiled = appJson.last_filed?moment(appJson.last_filed).tz("America/Vancouver").diff('2000-01-01','minutes'):0;
        app.lastFiledDate = appJson.last_filed?moment(appJson.last_filed).tz("America/Vancouver").format():'';                
        app.id = appJson.id;
        app.listOfPdfs = appJson.prepared_pdfs?appJson.prepared_pdfs.map(pdf=>pdf.pdf_type) :[]
        app.app_type = this.extractTypes(appJson.app_type.split(','));
        app.app_type_code = appJson.app_type.split(',');
        if(appJson.last_efiling_submission){
            app.last_efiling_submission = {package_number:appJson.last_efiling_submission.package_number, package_url:appJson.last_efiling_submission.package_url}
            if(appJson.last_efiling_submission.package_number) app.packageNum=appJson.last_efiling_submission.package_number;
            app.packageResults = appJson.last_efiling_submission.submission_results? appJson.last_efiling_submission.submission_results: ''
            app.fileNum = app.packageResults?.court?.fileNumber? app.packageResults.court.fileNumber: ''
            if(app.packageResults?.documents){
                // console.log(app.packageResults.documents.map(doc => doc?.status?.code))
                const statusCodes = app.packageResults.documents.map(doc => doc?.status?.code)
                app.rejected = statusCodes?.includes('REJ')
                const submitted = statusCodes.every(code => code.toUpperCase()=='SUB')
                const completed = statusCodes.every(code => code.toUpperCase()=='FILE')
                app.status = app.rejected? 'rejected': (submitted?'submitted':(completed?'completed':''))
                app.efilingDocs=app.packageResults.documents
            }
        }
        if(mainAppication) app.refApplications = this.tempRefApplications
        return app
    }

    public beginApplication() {   

        this.$store.dispatch("Application/UpdateInit", Vue.filter('get-current-version')());
        const userId = store.state.Common.userId;
        store.commit("Application/setUserId", userId);

        const lastUpdated = moment().format();
        store.commit("Application/setLastUpdated", lastUpdated);

        store.commit("Application/setRejectedPathway", false);
        store.commit("Application/setRejectedFileNumber", '');
        store.commit("Application/setRejectedFormsList", []);

        const userType = store.state.Application.userType;      
        store.commit("Application/setUserType", userType);

        const application = store.state.Application;
        application.type = store.state.Application.types.toString();

        const url = "/app/";
        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.post(url, application,header)
        .then(res => {
            this.applicationId = res.data.app_id;  
            store.commit("Application/setApplicationId", this.applicationId);
            this.error = "";
  
            this.$router.push({name: "flapp-surveys" }) 
        }, err => {
            console.error(err);
            this.error = err;
        });
    }

    public navigateToEFilingHub(packageInfo) {
        location.replace(packageInfo.package_url)
    }

    public resumeApplication(applicationId) {      
        this.showActionRequired=false;
        this.$http.get('/app/'+ applicationId + '/')
        .then((response) => {

            const applicationData = response.data   
            const applicationType = (applicationData.type?.length>0)?this.extractTypes(applicationData.type.split(',')):[];          
            
            const storeMigrationFn = new MigrateStore()           
            this.currentApplication = storeMigrationFn.migrate(applicationData, applicationType, Vue.filter('get-current-version')())

            const comStepFn = new RestoreCommonStep()
            comStepFn.restore(this.currentApplication)
           
            this.checkAllCompleted();
           
            this.$router.push({name: "flapp-surveys" }) 

        }, err => {
            this.error = err;        
        });
    }   

    public extractTypes(applicationTypes: string[]) {
        return Vue.filter('typesToFullnames')(applicationTypes)
    }

    public removeApplication(application, index) {
        this.deleteErrorMsg = '';
        this.deleteErrorMsgDesc = '';
        this.deleteError = false;
        this.applicationToDelete = application;
        this.indexToDelete = index;
        this.confirmDelete=true;         
    }    

    public confirmRemoveApplication() {
        this.$http.delete('/app/'+ this.applicationToDelete['id'] + '/')
        .then((response) => {
            this.loadApplications()            
            
        },err => {
            const errMsg = err.response.data.error;
            this.deleteErrorMsg = errMsg.slice(0,60) + (errMsg.length>60?' ...':'');
            this.deleteErrorMsgDesc = errMsg;
            this.deleteError = true;            
        });
        this.confirmDelete=false;  
    }
    
    public viewApplicationPdf(applicationId, listOfPdfs, efilingDocs, packageNumber) {
        this.printingApplicationId = applicationId;

        // console.log(efilingDocs)
        // console.log(packageNumber)
        this.printingListOfPdfs = []
        this.efilingListOfDocs = []
        for (const doc of efilingDocs){
            this.efilingListOfDocs.push({
                name: doc.documentProperties?.name?.replace('_generated',''),
                packageNumber: packageNumber,
                identifier: doc.identifier,
                description: doc.description
            })
        }


        if(this.efilingListOfDocs.length>0){
            this.showSelectFileForPrint =  true;
        }
        else{
            let submittedPdfList = []
            this.$http.get('/app/'+ applicationId + '/')
            .then((response) => {

                const applicationData = response.data;  
                const appSteps = applicationData?.steps.filter(step => step.name == 'GETSTART');
                if(appSteps.length == 1){ 
                    const stepGETSTART = appSteps[0].result;

                    if (stepGETSTART?.submittedPdfList){
                        submittedPdfList = stepGETSTART.submittedPdfList;
                    } 
                }
                
                this.printingListOfPdfs = this.getListOfPdfs(listOfPdfs,submittedPdfList);
                this.showSelectFileForPrint =  true;

            }, err => { 
                this.printingListOfPdfs = this.getListOfPdfs(listOfPdfs,submittedPdfList);           
                this.showSelectFileForPrint =  true;        
            });
        }
    }

    public getListOfPdfs(listOfPdfs, submittedPdfList){

        return listOfPdfs.filter(pdfname => {
            return (
                (pdfname != "TEMP") && 
                (submittedPdfList.includes(pdfname) ||
                 submittedPdfList.length == 0
                )
            )
        });
    }

    public viewInstructions(applicationId, applicationType) {
        this.instructionsApplicationId = applicationId;
        this.applicationTypes = applicationType;
        this.showInstructions =  true;
    }

    public displayRejectionInfo(applicationId, packageId, packageResults) {
        // console.log(packageResults)
        this.rejectedApplicationId = applicationId;
        this.rejectedPackageId = packageId
        this.packageResults = packageResults
        this.showActionRequired = true;
    }

    public printJourneyMap() {
        
        const pdf_name='process-map'
        const url = '/print-fillable-pdf?name='+pdf_name
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdf_name+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);     
            this.showJourneyMap =  false;        

        },err => {
            console.error(err);
        });
        
    }

    public downloadApplicationPdf(applicationId, pdf_type){
        
        const url = '/survey-print/'+applicationId+'/?pdf_type='+pdf_type
        const options = {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            }
        }  
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdf_type+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);  
            this.error = "";          
        },err => {
            console.error(err);
        });
    }


    public downloadEfilingDocument(fileName, packageNumber, identifier){
        
        const url = '/efiling/'+packageNumber+'/doc/'+identifier+'/'
        const options = {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            }
        }  
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = fileName;
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);  
            this.error = "";          
        },err => {
            console.error(err);
        });
    }

    public loadDocumentTypes() {
        this.$http.get('/efiling/document-types/')
        .then((response) => { 
            if(response.data && response.data.length>0){                
                this.UpdateDocumentTypesJson(response.data);
            }
        },(err) => {            
            console.log(err)
        });
    }

    public includesOtherForms(applicationId){
        const application = this.previousApplications.filter(app => app.id==applicationId)
        // console.log(applicationId)
        // console.log(application)
        if(application[0]){
            const app_type_code = application[0].app_type_code
            // console.log(app_type_code)
            const app_types = Vue.filter('getOtherFormsType')()
            // console.log(app_types) 
            for(const app_type of app_type_code){
                if(!app_types.includes(app_type)) return false
            }
            return true
        }
        return false
    }

    public extractFilingLocations() {
        GetFilingLocations();       
    }

    beforeCreate() {
        const Survey = SurveyVue;
        surveyEnv.setCss(Survey);
    }
}
